// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-badge][data-v-dd076df6]{position:absolute;height:18px;top:-5px;right:10px}[data-badge][data-v-dd076df6]:after{content:attr(data-badge);position:absolute;font-size:.7em;background:#d53457;color:#fff;width:18px;height:18px;text-align:center;line-height:18px;border-radius:50%;-webkit-box-shadow:0 0 1px #333;box-shadow:0 0 1px #333}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
